import styled, { css } from 'styled-components';
import { get } from '../constants.js';
import sx from '../sx.js';
import { toggleStyledComponent } from '../internal/utils/toggleStyledComponent.js';
import '../FeatureFlags/FeatureFlags.js';
import { useFeatureFlag } from '../FeatureFlags/useFeatureFlag.js';
import '../FeatureFlags/DefaultFeatureFlags.js';
import React from 'react';
import { clsx } from 'clsx';
import classes from './Header.module.css.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS_MODULES_FEATURE_FLAG = 'primer_react_css_modules_ga';
const StyledHeader = toggleStyledComponent(CSS_MODULES_FEATURE_FLAG, 'header', styled.header.withConfig({
  displayName: "Header__StyledHeader",
  componentId: "sc-1wu4agm-0"
})(["z-index:32;display:flex;padding:", ";font-size:", ";line-height:", ";color:", ";background-color:", ";align-items:center;flex-wrap:nowrap;overflow:auto;", ";"], get('space.3'), get('fontSizes.1'), get('lineHeights.default'), get('colors.header.text'), get('colors.header.bg'), sx));
const Header = /*#__PURE__*/React.forwardRef(function Header({
  children,
  className,
  ...rest
}, forwardRef) {
  const enabled = useFeatureFlag(CSS_MODULES_FEATURE_FLAG);
  return /*#__PURE__*/React.createElement(StyledHeader, _extends({
    ref: forwardRef,
    className: clsx(className, {
      [classes.Header]: enabled
    })
  }, rest), children);
});
Header.displayName = 'Header';
const StyledHeaderItem = toggleStyledComponent(CSS_MODULES_FEATURE_FLAG, 'div', styled.div.withConfig({
  displayName: "Header__StyledHeaderItem",
  componentId: "sc-1wu4agm-1"
})(["display:flex;margin-right:", ";align-self:stretch;align-items:center;flex-wrap:nowrap;", ";", ";"], get('space.3'), ({
  full
}) => full && css(["flex:auto;"]), sx));
const HeaderItem = /*#__PURE__*/React.forwardRef(function HeaderItem({
  children,
  className,
  ...rest
}, forwardRef) {
  const enabled = useFeatureFlag(CSS_MODULES_FEATURE_FLAG);
  return /*#__PURE__*/React.createElement(StyledHeaderItem, _extends({
    ref: forwardRef,
    className: clsx(className, enabled && classes.HeaderItem),
    "data-full": rest.full
  }, rest), children);
});
HeaderItem.displayName = 'Header.Item';
const StyledHeaderLink = toggleStyledComponent(CSS_MODULES_FEATURE_FLAG, 'a', styled.a.attrs(({
  to
}) => {
  const isReactRouter = typeof to === 'string';
  if (isReactRouter) {
    // according to their docs, NavLink supports aria-current:
    // https://reacttraining.com/react-router/web/api/NavLink/aria-current-string
    return {
      'aria-current': 'page'
    };
  } else {
    return {};
  }
}).withConfig({
  displayName: "Header__StyledHeaderLink",
  componentId: "sc-1wu4agm-2"
})(["font-weight:", ";color:", ";white-space:nowrap;cursor:pointer;text-decoration:none;display:flex;align-items:center;&:hover,&:focus{color:", ";}", ";"], get('fontWeights.bold'), get('colors.header.logo'), get('colors.header.text'), sx));
const HeaderLink = /*#__PURE__*/React.forwardRef(function HeaderLink({
  children,
  className,
  ...rest
}, forwardRef) {
  const enabled = useFeatureFlag(CSS_MODULES_FEATURE_FLAG);
  return /*#__PURE__*/React.createElement(StyledHeaderLink, _extends({
    ref: forwardRef,
    className: clsx(className, enabled && classes.HeaderLink)
  }, rest), children);
});
HeaderLink.displayName = 'Header.Link';
var Header$1 = Object.assign(Header, {
  Link: HeaderLink,
  Item: HeaderItem
});

export { Header$1 as default };
